








































































import FooterButton from "@/components/FooterButton.vue";
import DropDownButton from "@/components/DropDownButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData } from "@/models/app-data";
import { requiredIf, required } from "vuelidate/lib/validators";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { FinalDetailsContent } from "@/models/content/final-details";

@Component({
  components: {
    FooterButton,
    DropDownButton,
  },
  validations: {
    otherDetails: {
      required: requiredIf(function (model: FinalDetails): boolean {
        return model.selectedOption === model.lastChoice;
      }),
    },
  },
})
export default class FinalDetails extends Mixins(CommonMixin) {
  contentService = new ContentService();
  content = {} as FinalDetailsContent;
  appData = {} as AppData;
  additionalDetails = "";
  howHeard = "";
  PercentDone = 90;
  selectedOption = "";
  selectedIndex = 0;
  selected = "";
  otherDetails = "";
  textDirection = "ltr";
  lastChoice = ''

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getFinalDetailsContent();
      this.textDirection = contentService.TextDirection();
      this.lastChoice = this.content.Choices[this.content.Choices.length - 1];

      this.appData = this.getAppData();
      if (this.appData != null) {
        this.selectedOption = this.appData.howDidYouHear;
        this.additionalDetails = this.appData.additionalInfo;
        this.otherDetails = this.appData.howDidYouHearDetails;
        this.putWorkflowStep( this.appData.workflowId, "FinalDetails") 
      }
    } catch (error) {
      this.showError(error);
    }
  }

  disableNext(): boolean {
    return this.$v.$invalid;
  }

  public handleNextPageEvent(): void {
    this.appData.howDidYouHear = this.selectedOption;
    this.appData.howDidYouHearIndex = this.getSelectedIndex(this.selectedOption);
    this.appData.howDidYouHearLastIndex = this.content.Choices.length - 1;
    this.appData.additionalInfo = this.additionalDetails;
    // Check for 'other' options which should be the last choice
    if (this.appData.howDidYouHear === this.lastChoice) {
      this.appData.howDidYouHearDetails = this.otherDetails;
    } else {
      this.appData.howDidYouHearDetails = "";
    }
    this.saveAppData(this.appData);
    this.$router.push({ path: "FinalDetails2" });
  }

  public handleDropDownEvent(event: any): void {
    this.selectedOption = event;
    this.selectedIndex = this.content.Choices.indexOf(this.selectedOption);
  }

  private getSelectedIndex( option: string): number {
     return this.content.Choices.indexOf(option)
  }
}
